import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProcedureInstanceBase } from '../../model/procedure-instance/procedure-instance.model';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProcedureInstanceVisibilityBase } from '../../model/procedure-instance/procedure-instance-visibility.model';

@Injectable({
	providedIn: 'root'
})
export class ProcedureInstanceVisibilityService {

	protected resourceUrl: string = "/rest/publicarea/procedure-instance-visibility"

	protected visibility: Map<number, ProcedureInstanceVisibilityBase> = new Map<number, ProcedureInstanceVisibilityBase>();

	constructor(private http: HttpClient) { }

	public getVisibility(id: number): ProcedureInstanceVisibilityBase | undefined {
		return this.visibility.get(id)
	}
	createHeaderRef(id: number): { [header: string]: string } {
		let data = this.visibility.get(id)
		if (data == null) {
			return { "proc-ref": "no-word" }
		}

		return { "proc-ref": data.ref }
	}

	public check(data: ProcedureInstanceBase[]): Observable<ProcedureInstanceVisibilityBase[]> {
		let notFound: ProcedureInstanceBase[] = []
		let found: ProcedureInstanceVisibilityBase[] = []

		data.forEach(p => {
			let d = this.visibility.get(p.id)

			if (d == null) {
				let noVisible = new ProcedureInstanceVisibilityBase()
				noVisible.id = p.id
				this.visibility.set(p.id, noVisible)
				notFound.push(p)
				return
			}

			if (d != null && d.shared == false && d.ref != null) {
				found.push(d)
				return
			}
			notFound.push(p)
		})

		if (notFound.length == 0) {
			return of(found)
		}

		return this.http.post<ProcedureInstanceVisibilityBase[]>(`${this.resourceUrl}/check`, notFound.map(p => p.id)).pipe(map(r => {
			let responses: ProcedureInstanceVisibilityBase[] = r.map(p => ProcedureInstanceVisibilityBase.from(p))
			notFound.forEach(nt => {
				let data = responses.filter(f => f.id == nt.id)

				if (data.length == 0) {
					let element = this.visibility.get(nt.id)
					if (element == null) {
						return
					}
					found.push(element)
				}

				data.forEach(d => {
					let element = this.visibility.get(d.id)
					if (element == null) {
						return
					}
					element.copy(d)
					found.push(element)
				})
			})

			return found
		}))
	}
	
}
